export const loadState = (key) => {
    try {
        const serializedState = localStorage.getItem(key);
        if (serializedState === null) {
            return undefined;
        }
        return JSON.parse(serializedState);
    }
    catch (e) {
        console.error(e.message);
        return undefined;
    }
};
export const saveState = (key, value) => {
    try {
        if (value !== undefined) {
            const serializedState = JSON.stringify(value);
            localStorage.setItem(key, serializedState);
            return true;
        }
        return false;
    }
    catch (e) {
        console.error(e.message);
        return false;
    }
};
export default { loadState, saveState };
//# sourceMappingURL=localStore.js.map